import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import querystring from 'query-string';
import labelRequest from '../labelRequest';

export default function getWishlist(wishlistConfigs) {
    const { baseUrl, brandId, country, wishlistId, uberToken, clientId, clientSecret, options = {} } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getWishlist()');
    invariant(brandId, 'brandId is a required param of getWishlist()');
    invariant(country, 'country is a required param of getWishlist()');
    invariant(wishlistId, 'wishlistId is a required param of getWishlist()');
    invariant(options.guestAccessKey || uberToken, 'guestAccessKey or uberToken is a required param of getWishlist()');
    invariant(clientId, 'clientId is a required param of getWishlist()');

    const headers = { 'Content-Type': 'application/json' };

    const { guestAccessKey, ...rest } = options;

    let optionalQuery = options && Object.keys(options).length > 0 ? `?${querystring.stringify(rest)}` : '';

    optionalQuery = guestAccessKey ? optionalQuery + (optionalQuery !== '?' ? '&' : '') + 'guestAccessKey=' + guestAccessKey : optionalQuery;

    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/${wishlistId}${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getWishlist',
    );
}
